import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatChipsModule,
  MatIconModule,
  MatTabsModule,
  MatExpansionModule,
  MatCheckboxModule,
  MatCardModule
} from "@angular/material";
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
  NgbDatepickerModule,
  NgbAlertModule
} from "@ng-bootstrap/ng-bootstrap";
import { LocationUserAssignmentModalComponent } from "./location-user-assignment-modal/location-user-assignment-modal.component";
import { SearchListComponent } from "./search-list/search-list.component";
import { CustomDropdownComponent } from "./custom-dropdown/custom-dropdown.component";
import { CustomAccordionComponent } from "./custom-accordion/custom-accordion.component";
import { HeaderComponent } from "./header/header.component";
import { SessionTimeoutModalComponent } from "./session-timeout-modal/session-timeout-modal.component";
import { InfoModalComponent } from "./info-modal/info-modal.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { NoAccessComponent } from "./no-access/no-access.component";
import { VerifyCodeSentModalComponent } from "./verify-code-sent-modal/verify-code-sent-modal.component";
import { ReportDetailsModalComponent } from "./report-details-modal/report-details-modal.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import {HippaPdfComponent} from "./hippa-pdf/hippa-pdf.component";
import {PdfViewerModule} from "ng2-pdf-viewer";
import { PatientConsentToDrawComponent } from './patient-consent-to-draw/patient-consent-to-draw.component';
import { AgeVerificationComponent } from './age-verification/age-verification.component';
import {SharedModule} from "../modules";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    NgbAlertModule,
    FormsModule,
    MatTabsModule,
    PdfViewerModule,
    MatCardModule,
    MatCheckboxModule,
  ],
  exports: [
    // Modules
    NgbDropdownModule,
    FormsModule,
    NgbTooltipModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    NgbAccordionModule,
    NgbTypeaheadModule,
    NgbDatepickerModule,
    NgbAlertModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatCardModule,

    // Components
    SearchListComponent,
    NotFoundComponent,
    NoAccessComponent,
    InfoModalComponent,
    LocationUserAssignmentModalComponent,
    SearchListComponent,
    CustomDropdownComponent,
    CustomAccordionComponent,
    HeaderComponent,
    SpinnerComponent,
    HippaPdfComponent,
    PatientConsentToDrawComponent
  ],
  declarations: [
    SearchListComponent,
    NotFoundComponent,
    NoAccessComponent,
    InfoModalComponent,
    LocationUserAssignmentModalComponent,
    CustomDropdownComponent,
    CustomAccordionComponent,
    HeaderComponent,
    SessionTimeoutModalComponent,
    VerifyCodeSentModalComponent,
    ReportDetailsModalComponent,
    SpinnerComponent,
    HippaPdfComponent,
    PatientConsentToDrawComponent,
    PatientConsentToDrawComponent,
    AgeVerificationComponent
  ]
})
export class SharedComponentsModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/shared-components.module.ts